import React from 'react';

export default function LogoMark({ className = 'w-8 h-8', rounded = 'rounded-md' }) {
  return (
    <span className={`${className} ${rounded} bg-navy-900 ring-1 ring-white/10 flex items-center justify-center shrink-0 overflow-hidden`}>
      <svg viewBox="0 0 64 64" className="w-[62%] h-[62%]" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g transform="rotate(-8 32 32)">
          <rect x="8"  y="26" width="7" height="14" rx="1.5" fill="#fbbf24" />
          <rect x="18" y="18" width="7" height="22" rx="1.5" fill="#fbbf24" />
          <rect x="28" y="8"  width="7" height="32" rx="1.5" fill="#fcd34d" />
        </g>
      </svg>
    </span>
  );
}
